(function(){

    'use strict';

    angular.module('app').controller('BBAProfileManagerController', BBAProfileManagerController);

    BBAProfileManagerController.$inject = ['BBAProfileManagerTableService'];

    function BBAProfileManagerController(BBAProfileManagerTableService) {

        const vm = this;
        vm.bbaProfileManagerTable = new BBAProfileManagerTableService().tableData;

    }
})();


// WEBPACK FOOTER //
// ./js/controllers/BBAProfileManagerController.js